import React, { useState } from 'react';
import './Contact.css';

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 8H13M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    natureOfBusiness: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const logoUrl = process.env.REACT_APP_LOGO_URL || 'https://stratx.netlify.app/logo.png';
      const formPayload = {
        name: formData.name,
        email: formData.email,
        company: formData.company || 'N/A',
        phone: formData.phone || 'N/A',
        natureOfBusiness: formData.natureOfBusiness || 'N/A',
        message: formData.message,
        logoUrl,
        websiteUrl: 'https://www.stratx.us',
      };

      const response = await fetch('/.netlify/functions/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formPayload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        let errorData;
        try {
          errorData = JSON.parse(errorText);
        } catch {
          errorData = { error: errorText || `HTTP ${response.status}` };
        }
        throw new Error(errorData.error || `Server error: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        setSubmitStatus({
          type: 'success',
          message: 'Thank you! Your message has been sent. We will be in touch within one business day.',
        });
        setFormData({ name: '', company: '', email: '', phone: '', natureOfBusiness: '', message: '' });
        setTimeout(() => setSubmitStatus({ type: '', message: '' }), 6000);
      } else {
        throw new Error(result.error || 'Failed to send email');
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: 'Something went wrong. Please email us directly at businessdevelopment@stratx.us',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="sec">
      <div className="w">
        <div className="rv">
          <div className="eye">Get In Touch</div>
          <h2 className="sh">Ready to <span>Accelerate</span> Your Growth?</h2>
          <p className="sl">Let's start a conversation. Our team typically responds within one business day.</p>
        </div>
        <div className="cog">
          <div className="rv d1">
            <div className="coih">Contact Information</div>
            <div className="cois">Reach out directly or use the form — we're ready to discuss your growth objectives.</div>
            <div className="coit">
              <div className="coic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.34 11.5a19.79 19.79 0 01-3.07-8.67A2 2 0 013.45 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.91 8.44a16 16 0 006.29 6.29l.81-.81a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div>
                <div className="codl">Phone</div>
                <div className="codv">
                  <a href="tel:+918454060578">+91 84540 60578 (India)</a><br />
                  <a href="tel:+971501741137">+971 50 174 1137 (Dubai)</a>
                </div>
              </div>
            </div>
            <div className="coit">
              <div className="coic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div>
                <div className="codl">Email</div>
                <div className="codv">
                  <a href="mailto:businessdevelopment@stratx.us">businessdevelopment@stratx.us</a>
                </div>
              </div>
            </div>
            <div className="coit">
              <div className="coic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20" strokeLinecap="round" />
                </svg>
              </div>
              <div>
                <div className="codl">Website</div>
                <div className="codv">
                  <a href="https://www.stratx.us" target="_blank" rel="noopener noreferrer">www.stratx.us</a>
                </div>
              </div>
            </div>
          </div>
          <div className="fc2 rv d2">
            {submitStatus.message && (
              <div className={`fst ${submitStatus.type === 'success' ? 'ok' : 'er'}`}>
                {submitStatus.message}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="fr">
                <div className="fg2">
                  <label>Full Name <span className="req">*</span></label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your name" required />
                </div>
                <div className="fg2">
                  <label>Company</label>
                  <input type="text" name="company" value={formData.company} onChange={handleChange} placeholder="Your company" />
                </div>
              </div>
              <div className="fr">
                <div className="fg2">
                  <label>Email Address <span className="req">*</span></label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@company.com" required />
                </div>
                <div className="fg2">
                  <label>Phone Number</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 / +971" />
                </div>
              </div>
              <div className="fg2">
                <label>Nature of Business</label>
                <input type="text" name="natureOfBusiness" value={formData.natureOfBusiness} onChange={handleChange} placeholder="e.g. Manufacturing, Hospitality, Technology..." />
              </div>
              <div className="fg2">
                <label>Message <span className="req">*</span></label>
                <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Tell us about your business challenge or growth objective..." required />
              </div>
              <button type="submit" className="bp fsb" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : <>Send Message <ArrowIcon /></>}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
